import React from 'react';
import Fade from 'react-reveal/Fade';
import Text from 'common/components/Text';
import Button from 'common/components/Button';
import Heading from 'common/components/Heading';
import Rating from 'common/components/Rating';
import Container from 'common/components/UI/Container';
import {StaticImage} from 'gatsby-plugin-image';
import BannerWrapper, {BannerContent, BannerImage, ButtonGroup, RatingInfo} from './banner.style';

const Banner = () => {

  return (
    <BannerWrapper id="home">
      <Container>
        <BannerContent>
          <Fade up>
            <RatingInfo>
              <Rating rating={4} />
              4.9 of 5 By <StaticImage style={{marginLeft: '8px'}} src="../../../common/assets/image/instagram/icons/vector.png" layout="fixed" alt="Vector：PCアプリライブラリ"/>
            </RatingInfo>
          </Fade>
          <Fade up delay={100}>
            <Heading
              as="h1"
              content={<span>インスタグラムの<br/>フォロワーを増やす<br/>自動いいねアプリ</span>}
            />
          </Fade>
          <Fade up delay={200}>
            <Text content="リアルなフォロワーを増やしファンを獲得するための最初のステップは、自らいいねやフォローを行うことが最も効果的であると立証されています。" />
          </Fade>
          <Fade up delay={300}>
            <ButtonGroup>
              <a href="/product/autolikes-application"><Button className="primary" title="今なら１カ月無料キャンペーン中！" /></a>
              {/*<Button*/}
              {/*  className="text"*/}
              {/*  variant="textButton"*/}
              {/*  icon={<Icon icon={playCircle} />}*/}
              {/*  iconPosition="left"*/}
              {/*  title="Watch Video"*/}
              {/*/>*/}
            </ButtonGroup>
          </Fade>
        </BannerContent>
        <BannerImage>
          <Fade up delay={100}>
            {/*<GatsbyImage*/}
            {/*  src={*/}
            {/*    (Data.appScreenshot !== null) | undefined*/}
            {/*      ? Data.appScreenshot.childImageSharp.gatsbyImageData*/}
            {/*      : {}*/}
            {/*  }*/}
            {/*  alt="App Screenshot"*/}
            {/*/>*/}
            <StaticImage src="../../../common/assets/image/instagram/banner_image.png"　alt="インスタグラムのフォロワーを増やす自動いいねアプリ" />
          </Fade>
        </BannerImage>
      </Container>
    </BannerWrapper>
  );
};

export default Banner;
